import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { getIsNodeFile, getIsNodeFolder } from 'utils';

export default function useNodes(nodes: DataRoomNode[]) {
  const hasFiles = useMemo(() => nodes?.some(getIsNodeFile), [nodes]);
  const hasFolders = useMemo(() => nodes?.some(getIsNodeFolder), [nodes]);

  const { t } = useTranslation();

  const getCopyByNodeType = useCallback(
    (itemsCopy: string, foldersCopy: string, filesCopy: string, count = 0) =>
      t(
        hasFiles && hasFolders
          ? itemsCopy
          : hasFolders
          ? foldersCopy
          : filesCopy,
        { count },
      ),
    [hasFiles, hasFolders, t],
  );

  return { hasFiles, hasFolders, getCopyByNodeType };
}
